import React from 'react';
import { Typography, Grid, Divider, Avatar, Box } from '@mui/material';

import Logo from '../../../assets/img/clubhouse_logo.png';
import LogoOK from '../../../assets/img/okbingo.png';
import LogoWin from '../../../assets/img/wingames.png';
import LogoNT from '../../../assets/img/norksTipping.png';
import LogoKiosk from '../../../assets/img/kiosk.png';
import LogoEBS from '../../../assets/img/ebs.png';

import { useTranslation } from 'react-i18next';

function VendorItemHeader({ vendor }) {
  const { t } = useTranslation();

  const logoSrc =
    (vendor.name.slice(0, 9) === 'Clubhouse' ? Logo : '') ||
    (vendor.name === 'OK Databingo' ? LogoOK : '') ||
    (vendor.name === 'WinGames' ? LogoWin : '') ||
    (vendor.name === 'Norsk Tipping' ? LogoNT : '') ||
    (vendor.name === 'Kiosk' ? LogoKiosk : '') ||
    (vendor.name === 'EBS' ? LogoEBS : '') ||
    (vendor.name === t('sales.paper') ? Logo : '');

  const imageSx =
    (vendor.name === 'Norsk Tipping' && {
      width: 'auto',
      height: '100% !important',
      paddingTop: 0,
    }) ||
    (vendor.name === 'EBS' && {
      width: 'auto',
      height: '85%',
      paddingTop: 0,
    }) ||
    (vendor.name.slice(0, 9) === 'Clubhouse' && {
      height: '100%',
      width: 'auto',
      paddingTop: 0,
    }) ||
    (vendor.name === t('sales.paper') && {
      height: '100%',
      width: 'auto',
      paddingTop: 0,
    }) ||
    (vendor.name.slice(0, 9) === 'Kiosk' && {
      height: '80%',
      width: 'auto',
      paddingTop: 0,
    }) ||
    (vendor.name.slice(0, 9) !== 'Clubhouse' &&
      vendor.name !== 'Kiosk' &&
      vendor.name !== t('sales.paper') && {
        width: '100%',
        height: 'auto',
        paddingTop: 0,
      }) ||
    (vendor.name.slice(0, 9) !== 'Clubhouse' &&
      vendor.name === 'Kiosk' && {
        width: '100%',
        height: 'auto',
        paddingTop: 0,
      });

  return (
    <Grid
      container
      sx={{
        width: '100%',
        mb: 1.5,
      }}
    >
      {/* Row: logo left, title right */}
      <Grid item xs={12}>
        <Grid
          container
          alignItems="center"
          wrap="nowrap"
          sx={{ width: '100%' }}
        >
          {/* LEFT: circular logo */}
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              mr: 2,
            }}
          >
            <Avatar
              sx={{
                bgcolor: 'rgba(0,0,0,0.2)',
                width: 72,
                height: 72,
              }}
              variant="circular"
            >
              {logoSrc && (
                <Box
                  component="img"
                  sx={{
                    width: '80%',
                    height: '80%',
                    objectFit: 'contain',
                    ...imageSx,
                  }}
                  alt={vendor.name}
                  src={logoSrc}
                />
              )}
            </Avatar>
          </Grid>

          {/* RIGHT: bigger title */}
          <Grid
            item
            xs
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              minWidth: 0,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: '1.9rem', // slightly bigger than before
                fontWeight: 700,
                lineHeight: 1.1,
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              {vendor.name}
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Separator line under header */}
      <Grid item xs={12}>
        <Divider
          sx={{
            mt: 1.5,
            borderColor: 'black',
            borderWidth: '1.5px',
            opacity: 0.7,
          }}
        />
      </Grid>
    </Grid>
  );
}

export default VendorItemHeader;
